<div class="contact-bubble-container" [ngClass]="messageSource ? 'sending' : 'receiving'" (click)="viewContact()">
  <div class="avatar-container">
    <div class="placeholder-img"></div>
    <div class="user-img"></div>
  </div>
  <div class="username-container">
    <div class="long-name">{{ displayName }}</div>
  </div>
  <div class="check-tick">
    @if (messageSource) {
      <app-read-receipt class="read-receipt" [messageStatus]="content['messageStatus']"></app-read-receipt>
    }
  </div>
</div>

@if (showViewContact) {
  <div class="view-contact-container">
    <div class="view-contact-header">
      <div class="contact-title">View Contact</div>
      <div class="close-btn" (click)="viewContact()">x</div>
    </div>
    <div class="view-contact-body">
      <div class="user-info">
        <div class="avatar-container">
          <div class="placeholder-img"></div>
        </div>
        <div class="username-container">
          <div class="name">{{ displayName }}</div>
          @if (organisationName) {
            <div class="sub-title-container">
              <span class="org-icon icons"></span>
              <span class="sub-title">{{ organisationName }}</span>
            </div>
          }
        </div>
      </div>
      @if (address) {
        <div class="home-address">
          @for (addr of address; track addr) {
            <div class="title">{{ addr.display }}</div>
            <div class="sub-title-container">
              <span class="home-icon icons"></span>
              <span class="sub-title">{{ addr.type }}</span>
            </div>
            <div class="hr-line"></div>
          }
        </div>
      }
      @if (emailAddress) {
        <div class="office-email">
          @for (email of emailAddress; track email) {
            <div class="title">{{ email.display }}</div>
            <div class="sub-title-container">
              <span class="at-icon icons"></span>
              <span class="sub-title">{{ email.type }}</span>
            </div>
            <div class="hr-line"></div>
          }
        </div>
      }
      @if (phoneNumbers) {
        <div class="home-phone">
          @for (phone of phoneNumbers; track phone) {
            <div class="title">{{ phone.display }}</div>
            <div class="sub-title-container">
              <span class="phone-icon icons"></span>
              <span class="sub-title">{{ phone.type }}</span>
            </div>
            <div class="hr-line"></div>
          }
        </div>
      }
      @if (urlAddresses) {
        <div class="office-web">
          @for (url of urlAddresses; track url) {
            <div class="title">{{ url.display }}</div>
            <div class="sub-title-container">
              <span class="link-icon icons"></span>
              <span class="sub-title">{{url.type}}</span>
            </div>
            <div class="hr-line"></div>
          }
        </div>
      }
      @if (contact.birthday) {
        <div class="birthday">
          <div class="title">{{ birthdayDisplay }}</div>
          <div class="sub-title-container">
            <span class="birthday-icon icons"></span>
            <span class="sub-title">BIRTHDAY</span>
          </div>
        </div>
      }
    </div>
  </div>
}